import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import {
  Container as ContainerBase,
  ContentWithPaddingXl,
} from "components/misc/Layouts";
import { SectionDescription } from "components/misc/Typography";
import logo from "../../images/logo_aori.svg";

const Container = tw.div`
  my-8 lg:my-10 text-gray-900 -mx-8 px-8
  [background:linear-gradient(to_bottom,_#f7fdf5,_#cfe4bd)]
`;
const HeadingContainer = tw.div``;
const Heading = tw(SectionHeading)`
  sm:text-3xl 
  md:text-4xl 
  lg:text-5xl 
  italic 
  font-serif
`;
const Subheading = tw(SubheadingBase)`text-gray-100 text-center`;
const Description = tw(
  SectionDescription
)`text-gray-400 text-center mx-auto max-w-screen-md [color:#1e3218]`;

const LogoContainer = tw.div`flex items-center justify-center`;
const LogoImg = tw.img`w-64`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const StatsContainer = tw.div`mt-8 flex flex-col sm:flex-row items-center justify-center flex-wrap max-w-screen-md justify-between mx-auto`;
const Stat = tw.div`flex flex-col text-center p-4 tracking-wide`;
const StatKey = tw.div`text-xl font-medium`;
const StatValue = tw.div`text-4xl sm:text-3xl md:text-4xl lg:text-5xl font-black`;

export default ({
  subheading = "",
  heading = "Coming Soon ...",
  description = "Quality In Every Mold",
  stats = [
    {
      key: "Clients",
      value: "2500+",
    },
    {
      key: "Revenue",
      value: "$100M+",
    },
    {
      key: "Employees",
      value: "150+",
    },
  ],
}) => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <LogoContainer>
          <LogoImg src={logo} />
        </LogoContainer>
        <HeadingContainer>
          {subheading && <Subheading>{subheading}</Subheading>}
          <Heading>{heading}</Heading>
          {description && <Description>{description}</Description>}
        </HeadingContainer>
        {/* <StatsContainer>
          {stats.map((stat, index) => (
            <Stat key={index}>
              <StatValue>{stat.value}</StatValue>
              <StatKey>{stat.key}</StatKey>
            </Stat>
          ))}
        </StatsContainer> */}
      </ContentWithPaddingXl>
    </Container>
  );
};
